export default __webpack_public_path__ + "static/media/good-1.137fe13c.png";